class Hamburger {

  constructor(elem) {
    this.hamburger = elem;
	}

  initialize() {
    this.hamburger.on('click', function() {
      let menu = $('[data-menu]');

			menu.toggleClass('active');
      if (menu.hasClass('active')) {
        $('body').addClass('overflow');
        $('html').addClass('overflow');
      } else {
        $('body').removeClass('overflow');
        $('html').removeClass('overflow');
      }
    });
	}
}

export {Hamburger};

$(window).on('load', () => {
  let hamburgers = [];

  if ($('[data-hamburger]').length > 0) {
		$('[data-hamburger]').each(function(i) {
			hamburgers[i] = new Hamburger($(this));
			hamburgers[i].initialize();
		});
	}
});
